<div class="button-group-title" *ngIf="title">{{ title }}</div>
<div class="content" *ngIf="showSwiper">
	<swiper [config]="config">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</swiper>
</div>
<div class="content" *ngIf="!showSwiper">
	<ng-container *ngTemplateOutlet="content"></ng-container>
</div>
<dodo-cta-pointer
	*ngIf="showPointer && !showSwiper && !hidePointer"
	[totalStops]="_totalStops"
	[pointAtStopeNumber]="_pointerPosition"
></dodo-cta-pointer>

<ng-template #content><ng-content></ng-content></ng-template>
